import type { paths } from '../../types/yakubato-lp-api';
import { request, type OpenApiFetchClient } from './types';

export type GetMedicalInstitutions200Response =
  paths['/medical_institutions']['get']['responses']['200']['content']['application/json'];

export function createMedicalInstitutionsApi(client: OpenApiFetchClient) {
  return {
    getMedicalInstitutions() {
      return request<GetMedicalInstitutions200Response>(
        client.GET('/medical_institutions'),
      );
    },
  };
}
